import { setMyHomeExists } from 'shared/actions/valuationTraps/actions';
import { fetchIsMyHomeObjectsExist } from 'shared/services/valuationTraps/fetchIsMyHomeObjectsExist';
import { IThunkActionCreator } from 'shared/store';

export const getMyHomeObjectsExists = (): IThunkActionCreator<Promise<void>> => async (dispatch, getState, context) => {
  try {
    const res = await fetchIsMyHomeObjectsExist(context);

    dispatch(setMyHomeExists(res as boolean));
  } catch (e) {
    dispatch(setMyHomeExists(false));
  }
};
